import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import '@fortawesome/fontawesome-free/css/all.css' // 引入 Font Awesome
import './styles/design-system.css' // 引入设计系统（必须在 global.css 之前）
import './styles/global.css'
import './styles/infinite-end-tip.css'
// 配置axios拦截器，统一处理ID转换
import '@/shared/utils/axios'
import {
  absorbOAuthErrorFromUrl,
  absorbOAuthTokenFromUrl,
} from '@/shared/utils/wxMpOAuth'

absorbOAuthTokenFromUrl()
absorbOAuthErrorFromUrl()
// 防爬：初始化行为追踪（滚动、鼠标、点击、停留时间），随请求头上报
import { initBehaviorTracking, markPageEntered } from '@/shared/utils/antiCrawler'
initBehaviorTracking()

const app = createApp(App)
const pinia = createPinia()

app.use(router)
// 每次进入路由（含首页、详情、阅读页等）重置「当前页进入时间」，dwellTimeMs 表示当前页停留时长
router.afterEach(() => markPageEntered())
app.use(pinia)
app.use(ElementPlus, { locale: zhCn })

// 让 Element Plus 组件默认使用 rem
app.component('ElConfigProvider', {
  template: `
    <el-config-provider :size="'default'">
      <slot></slot>
    </el-config-provider>
  `
})

app.mount('#app')
